module.exports = "<div class=\"wrapper wrapper-content animated fadeInUp\"> <div class=ibox> <breadcrumb paths=paths></breadcrumb> <iframe-template path-url={{url}} css=100% key=normal></iframe-template> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/statistics/chartAnalysis/normal/view/normal.html
// module id = iWQa
// module chunks = 0